import React from "react";
import { i18n } from "../../../services/i18nService";
import { FrameIcon, Text } from "../../../services/visualLibraryService";
import {
  ListStyled,
  ProfileWrapper,
  Spacer,
  ProfileSubtextStyled,
  HeaderTextStyled
} from "../../Settings/styles/Styled";

export const Profile = ({ userAccount }) => {
  const userAccountData = {
    [`${i18n.get("pages.settings.profile.emailNumber")}`]:
      userAccount && userAccount.emailAddress ? userAccount.emailAddress : userAccount.mobilePhone
  };

  const entries = Object.entries(userAccountData);

  return (
    <>
      <ProfileWrapper>
        <FrameIcon name="profile" alignSelf="start" />
        <HeaderTextStyled rank="1" text={i18n.get(`pages.settings.menu.accountDetails`)} size="large" />
        <ProfileSubtextStyled rank="1" text={i18n.get(`pages.settings.menu.accountSettingsSubText`)} size="xmedium" />
      </ProfileWrapper>
      <Spacer />
      {entries.map(name => (
        <ListStyled key={name[0]}>
          <Text size="small" text={name[0]} rank="1" type="greyLight" />
          <Text className="keyHeading" size="xmedium" text={name[1]} rank="2" />
        </ListStyled>
      ))}
    </>
  );
};
